import { ROUTE_NAMES_ASSETS_OBJECT_TYPE_CONFIGURATION } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const assetsObjectTypeConfigurationRoute: InvariantRoute = {
	name: ROUTE_NAMES_ASSETS_OBJECT_TYPE_CONFIGURATION,
	path: '/assets/configure/object-type/:objectTypeId',
};
